export default "__VITE_ASSET__DPC$Verq__"